import { useState } from "react";
import MainLayout from "@/components/feature/MainLayout";
import ResidentStats from "./components/ResidentStats";
import ResidentAIInsight from "./components/ResidentAIInsight";
import ResidentTable from "./components/ResidentTable";
import UserPortraitPanel from "./components/UserPortraitPanel";

export default function ResidentPage() {
  const [search, setSearch] = useState("");
  const [filterStatus, setFilterStatus] = useState("全部");
  const [addModal, setAddModal] = useState(false);

  return (
    <MainLayout>
      <div className="space-y-4">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-lg font-bold text-gray-900">居民用户档案</h2>
            <p className="text-xs text-gray-400 mt-0.5">管理所有居民燃气用户信息、用气记录与账户状态</p>
          </div>
          <div className="flex gap-2">
            <button className="flex items-center gap-2 px-4 py-2 border border-gray-200 text-gray-600 text-sm rounded-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-download-line"></i>批量导入
            </button>
            <button onClick={() => setAddModal(true)} className="flex items-center gap-2 px-4 py-2 bg-[#E8531A] text-white text-sm rounded-lg hover:bg-[#d44a15] transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-user-add-line"></i>新增用户
            </button>
          </div>
        </div>

        {/* Stats */}
        <ResidentStats />

        {/* AI Insight */}
        <ResidentAIInsight />

        {/* User Portrait & AI Analysis */}
        <UserPortraitPanel />

        {/* Filters */}
        <div className="bg-white rounded-xl p-4 border border-gray-100 flex items-center gap-3 flex-wrap">
          <div className="relative flex-1 min-w-48">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"></i>
            <input
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="搜索姓名、手机号、用户编号..."
              className="w-full pl-8 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:border-[#E8531A]/50"
            />
          </div>
          <div className="flex gap-1 bg-gray-100 rounded-lg p-1">
            {["全部", "正常", "欠费预警", "停气"].map(s => (
              <button
                key={s}
                onClick={() => setFilterStatus(s)}
                className={`px-3 py-1.5 text-xs rounded-md transition-colors cursor-pointer whitespace-nowrap font-medium ${filterStatus === s ? "bg-white text-[#E8531A] shadow-sm" : "text-gray-500 hover:text-gray-700"}`}
              >
                {s}
              </button>
            ))}
          </div>
          <button className="flex items-center gap-1.5 text-xs text-gray-500 border border-gray-200 px-3 py-2 rounded-lg hover:bg-gray-50 cursor-pointer whitespace-nowrap">
            <i className="ri-filter-3-line"></i>高级筛选
          </button>
        </div>

        {/* Table */}
        <ResidentTable search={search} filterStatus={filterStatus} />
      </div>

      {/* Add User Modal */}
      {addModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50" onClick={() => setAddModal(false)}>
          <div className="bg-white rounded-2xl p-6 w-[520px] max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-5">
              <h3 className="text-base font-bold text-gray-900">新增居民用户</h3>
              <button onClick={() => setAddModal(false)} className="w-7 h-7 flex items-center justify-center rounded-full hover:bg-gray-100 cursor-pointer">
                <i className="ri-close-line text-gray-500"></i>
              </button>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {[
                { label: "用户姓名", placeholder: "请输入真实姓名", type: "text" },
                { label: "手机号码", placeholder: "11位手机号", type: "tel" },
                { label: "身份证号", placeholder: "18位身份证号", type: "text" },
                { label: "联系地址", placeholder: "详细安装地址", type: "text" },
                { label: "表计编号", placeholder: "IC卡表编号", type: "text" },
                { label: "初始余额", placeholder: "账户初始余额（元）", type: "number" },
              ].map((f, i) => (
                <div key={i} className={i === 3 ? "col-span-2" : ""}>
                  <label className="text-xs text-gray-500 mb-1 block">{f.label}</label>
                  <input type={f.type} placeholder={f.placeholder} className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#E8531A]" />
                </div>
              ))}
              <div>
                <label className="text-xs text-gray-500 mb-1 block">用户类型</label>
                <select className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#E8531A]">
                  <option>居民用户</option>
                  <option>低保用户</option>
                  <option>五保户</option>
                </select>
              </div>
              <div>
                <label className="text-xs text-gray-500 mb-1 block">所属区域</label>
                <select className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#E8531A]">
                  <option>朝阳区</option>
                  <option>海淀区</option>
                  <option>丰台区</option>
                  <option>西城区</option>
                </select>
              </div>
            </div>
            <div className="flex gap-2 mt-5">
              <button onClick={() => setAddModal(false)} className="flex-1 border border-gray-200 text-gray-600 py-2.5 rounded-lg text-sm cursor-pointer hover:bg-gray-50 whitespace-nowrap">取消</button>
              <button onClick={() => setAddModal(false)} className="flex-1 bg-[#E8531A] text-white py-2.5 rounded-lg text-sm cursor-pointer hover:bg-[#d44a15] whitespace-nowrap">确认新增</button>
            </div>
          </div>
        </div>
      )}
    </MainLayout>
  );
}
